import { defineMessages } from 'react-intl';

export const i18n: {
	project: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterProjectPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterProjectLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterProjectLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spaces: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterSpacesPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterSpacesLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterSpacesLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	project: {
		id: 'search-page.filters.names.project',
		defaultMessage: 'Project',
		description:
			'The text is shown as the filter name label in the search filter bar, allowing users to narrow Jira results by project.',
	},
	jiraFilterProjectPlaceholder: {
		id: 'search-page.jira.filter.project.placeholder',
		defaultMessage: 'Find projects',
		description: 'Placeholder for project filter search input',
	},
	jiraFilterProjectLabelSelected: {
		id: 'search-page.jira.filter.project.selected',
		defaultMessage: 'Selected',
		description:
			'The text is shown as a section heading in the Jira project filter drop-down, grouping projects the user has already selected.',
	},
	jiraFilterProjectLabelUnselected: {
		id: 'search-page.jira.filter.project.unselected',
		defaultMessage: 'Suggested',
		description:
			'The text is shown as a section heading in the Jira project filter drop-down, grouping recommended projects not yet selected.',
	},
	spaces: {
		id: 'search-page.filters.names.spaces',
		defaultMessage: 'Space',
		description:
			'The text is shown as the filter name label in the search filter bar, allowing users to narrow results by Confluence space.',
	},
	jiraFilterSpacesPlaceholder: {
		id: 'search-page.jira.filter.spaces.placeholder',
		defaultMessage: 'Find spaces',
		description:
			'The text is shown as placeholder text in the spaces search input within the Jira filter drop-down, prompting the user to type and find a space.',
	},
	jiraFilterSpacesLabelSelected: {
		id: 'search-page.jira.filter.spaces.selected',
		defaultMessage: 'Selected',
		description:
			'The text is shown as a section heading in the Jira spaces filter drop-down, grouping spaces the user has already selected.',
	},
	jiraFilterSpacesLabelUnselected: {
		id: 'search-page.jira.filter.spaces.unselected',
		defaultMessage: 'Suggested',
		description:
			'The text is shown as a section heading in the Jira spaces filter drop-down, grouping recommended spaces not yet selected.',
	},
});
